import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Button from '@shared/Button/Button';
import QuestionsItem from './Item/QuestionsItem';
import classes from './Questions.module.scss';
import { useWindowSize } from '@hooks/useWindowSize';
import { useSelector } from 'react-redux';
import { allQuestionsCountSelector, faqSelector } from '@models/faq/selectors';
import { useTypedDispatch } from '@hooks/useTypedDispatch';
import { faqConfig } from '@configs/faq';
import { triggerMetricsEvent } from '@metrics';
const { maxShowedCount } = faqConfig;
const Questions = () => {
    const [isAllShown, setAllShown] = useState(false);
    const questionsToShow = isAllShown ? 'all' : maxShowedCount;
    const questionsList = useSelector((state) => faqSelector(state, questionsToShow));
    const allQuestionsCount = useSelector(allQuestionsCountSelector);
    const { width } = useWindowSize();
    const { faqModel: { getQuestions }, } = useTypedDispatch();
    useEffect(() => {
        getQuestions();
    }, []);
    const handleMoreClick = () => {
        setAllShown(true);
        triggerMetricsEvent({ element: 'faqMoreButton' });
    };
    const isButtonShown = !isAllShown && allQuestionsCount > maxShowedCount;
    return (_jsxs(_Fragment, { children: [_jsx("ul", { children: questionsList.map((item, index) => (_jsx(QuestionsItem, { item: item }, index))) }), isButtonShown && (_jsx(Button, { variant: "secondary", size: "lg", text: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0435\u0449\u0435", full: width < 960, className: classes.btn, onClick: handleMoreClick }))] }));
};
export default Questions;
